let header = document.querySelector(".header");
let headerBtn = document.querySelector(".header__cbtnsMenu");
let headerMenu = document.querySelector(".header__menu");

const searchBtn = document.querySelector(".header__cbtnsSearchIcon");
const searchBlur = document.querySelector(".header__blur");
const search = document.querySelector(".header__cbtnsSearch");

headerBtn.addEventListener("click", () => {
    search.classList.remove("is-on");
    searchBlur.classList.remove("is-on");
    header.classList.toggle("is-on");
    noscroll(header.classList.contains("is-on"));
});

headerMenu.addEventListener("click", (e) => {
    if (e.target === e.currentTarget) {
        search.classList.remove("is-on");
        searchBlur.classList.remove("is-on");
        header.classList.remove("is-on");
        noscroll(header.classList.contains("is-on"));
    }
});

// search.addEventListener("mouseenter", () => {
//     search.classList.add("pc-is-on");
// });

search.addEventListener("mouseleave", () => {
    const googleSearchOr = document.querySelector(
        ".gsc-results-wrapper-overlay"
    );
    if (!googleSearchOr.classList.contains("gsc-results-wrapper-visible")) {
        search.classList.remove("pc-is-on");
    }
});

searchBtn.addEventListener("click", () => {
    search.classList.toggle("is-on");
    searchBlur.classList.toggle("is-on");
    header.classList.remove("is-on");
});

searchBlur.addEventListener("click", () => {
    search.classList.remove("is-on");
    searchBlur.classList.remove("is-on");
    header.classList.remove("is-on");
});

function noscroll(bool) {
    if (bool) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "";
    }
}

function disableScroll(event) {
    event.preventDefault();
}
